import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-14 px-4 bg-white border-y-2 border-gray-200" data-id="element-104">
      <div className="max-w-4xl mx-auto text-center" data-id="element-105">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 bg-brand-secondary rounded-full mb-5 shadow-lg border-4 border-white outline outline-4 outline-brand-secondary/30" data-id="element-106">
          <ShieldCheck className="w-7 h-7 md:w-10 md:h-10 text-brand-text" data-id="element-107" />
        </div>

        <h2 className="text-xl md:text-3xl font-black mb-4 text-brand-text uppercase tracking-tight" data-id="element-108">
          🏆 14 DÍAS DE GARANTÍA TOTAL
        </h2>

        <div className="text-sm md:text-base font-medium space-y-3 text-brand-steel max-w-3xl mx-auto leading-relaxed" data-id="element-109">
          <p data-id="element-110">
            Tenés 14 días completos para descargar y revisar todo el material.
          </p>
          <p className="font-bold text-brand-text bg-brand-bg p-4 md:p-5 rounded-xl border border-gray-200 shadow-sm" data-id="element-111">
            Si sentís que estas guías no valen cada centavo que pagaste, te
            devolvemos el 100% de tu dinero de forma inmediata. Sin preguntas.
            El riesgo es todo mío.
          </p>
        </div>
      </div>
    </section>;
}